import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import './UserReviews.scss';
import { Button, Spinner } from 'reactstrap';
import {
  columnFilter,
  dateFormatter,
  myReviewslinkFormatter,
  capitalize,
} from '../../components/TableComponents/TableComponents';
import { service, numberWithCommas } from '../../helpers';
import { SearchForm } from '../../components/forms/SearchForm';

export default class UserReviews extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      data: {},
      error: false,
      errorMsg: null,
      nextUrl: null,
      prevUrl: null,
      count: null,
    };
    this.defaultUrl = 'zombie/user-submissions/';
    this.pathName = null;
  }

  componentDidMount = () => {
    this.pathName = this.props.location.pathname;
    if (this.props.location.search !== '') {
      const params = new URLSearchParams(this.props.location.search);
      this.loadData(`${this.defaultUrl}?${params.toString()}`);
    } else {
      this.loadData(this.defaultUrl);
    }
  };

  componentDidUpdate = (prevProps) => {
    if (!this.state.loaded) {
      this.loadData();
    }
    if (prevProps.location.search !== this.props.location.search) {
      const params = new URLSearchParams(this.props.location.search);
      this.loadData(`${this.defaultUrl}?${params.toString()}`);
    }
  };

  search = (values) => {
    const params = new URLSearchParams();
    for (const k in values) {
      if (values[k]) {
        params.append(k, values[k]);
      }
    }
    const qs = params.toString();
    const pathName = this.props.location.pathname;
    this.props.history.push(`${pathName}?${qs}`);
  };

  loadData = async (url) => {
    try {
      const response = await service.get(url);
      const next = response.next ? new URL(response.next).search : null;
      const pre = response.previous ? new URL(response.previous) : null;
      const prev = pre ? (pre.search ? pre.search : '') : null;
      this.setState({
        loaded: true,
        data: response.results,
        count: response.count,
        nextUrl: next ? this.pathName + next : null,
        prevUrl: prev !== null ? this.pathName + prev : null,
      });
    } catch (e) {
      this.setState({ loaded: true, error: true, errorMsg: e });
    }
  };

  render = () => {
    if (this.state.error) {
      return (
        <div>
          error:{' '}
          {this.state.errorMsg.status
            ? this.state.errorMsg.statusText
            : this.state.errorMsg.message}
        </div>
      );
    }
    const data = {};
    const formVals = new URLSearchParams(this.props.location.search);
    formVals.forEach((value, key) => {
      data[key] = value;
    });

    return (
      <div>
        {this.state.loaded ? (
          <div className='reviewsView'>
            <div className='submissionType'>User Submission Reviews</div>
            <SearchForm handleSubmit={this.search} data={data} />
            <ReactTable
              data={this.state.data}
              defaultSorted={[{ id: 'createdOn', desc: true }]}
              defaultPageSize={15}
              showPagination={false}
              className='-striped -highlight'
              columns={[
                {
                  Header: 'User Phone',
                  width: 150,
                  accessor: 'metaData.phoneNumber',
                  Filter: columnFilter,
                },
                {
                  Header: 'Task ID',
                  width: 200,
                  accessor: 'metaData.taskId',
                  Filter: columnFilter,
                },
                {
                  Header: 'Brand',
                  width: 100,
                  accessor: 'metaData.brand.name',
                  Filter: columnFilter,
                },
                {
                  Header: 'Retailer',
                  width: 120,
                  accessor: 'metaData.store.retailer.name',
                  Filter: columnFilter,
                },
                {
                  Header: 'Country',
                  width: 100,
                  accessor: 'metaData.brand.country.name',
                  Filter: columnFilter,
                },
                {
                  Header: 'Submission Result',
                  width: 150,
                  accessor: 'submissionResult',
                  Cell: (props) => capitalize(props),
                  Filter: columnFilter,
                },
                {
                  Header: 'Task Value',
                  width: 100,
                  accessor: 'taskValue',
                  Filter: columnFilter,
                },
                {
                  Header: 'Bonus',
                  width: 100,
                  accessor: 'bonusValue',
                  Filter: columnFilter,
                },
                {
                  Header: 'Reviewed By',
                  width: 150,
                  accessor: 'user.username',
                  Filter: columnFilter,
                },
                {
                  Header: 'Submitted Date',
                  width: 200,
                  accessor: 'metaData.createdOn',
                  Cell: (props) => dateFormatter(props),
                  Filter: columnFilter,
                  className: 'tableCenter',
                },
                {
                  Header: 'Review Date',
                  width: 200,
                  accessor: 'createdOn',
                  Cell: (props) => dateFormatter(props),
                  Filter: columnFilter,
                  className: 'tableCenter',
                },
                {
                  Header: '',
                  width: 60,
                  accessor: 'metaData.id',
                  Cell: (props) => myReviewslinkFormatter(props),
                  filterable: false,
                  className: 'tableCenter',
                },
              ]}
            />
            <div className='pageButtonDiv'>
              <div className='navigation-botton-container'>
                <div className='itemCount'>
                  <p>
                    <span>{'Count '}</span>
                    {this.state.count
                      ? numberWithCommas(this.state.count)
                      : '0'}
                  </p>
                </div>
                <Button
                  disabled={!this.state.prevUrl}
                  onClick={() => this.props.history.push(this.state.prevUrl)}
                >
                  Previous page
                </Button>
                <Button
                  disabled={!this.state.nextUrl}
                  onClick={() => this.props.history.push(this.state.nextUrl)}
                >
                  Next page
                </Button>
              </div>
            </div>
          </div>
        ) : (
          <div className='loading-spinner-container'>
            <Spinner animation='grow' role='status'>
              <span>Loading...</span>
            </Spinner>
          </div>
        )}
      </div>
    );
  };
}
